import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from "jquery";
import NumericCellDinamic from './NumericTextDinamic';

var optionsCapacidades = [];
var isDisabledCorrelativa = true;
var thisState;

class DropDownCellCapacidadesFDO extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      CorrelativaDados: false
    };
  
  }

  componentDidMount() {
    thisState = this;

    (async () => {
      const data = {}
      const TipoVasilha = await services.apiCall.requestApi(
          "/Fiscalizacao/GetCapacidades",
          data,
          "get"
      );
      
      TipoVasilha.map((tipo) => (
        optionsCapacidades.push({text: tipo.cl + ' cl', value: tipo.idcapacidade})
      ));
    })();
  }

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
  });
  NumericCellDinamic.ChangeValueById("Capacidade" , e.target.value);
  }

  static isDisabled(isDisabled){
    isDisabledCorrelativa = isDisabled;

    thisState.setState({ CorrelativaDados : true });
    
  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';
    var indexId = dataItem.ProductID;
    if(dataItem.inEdit == true){
      indexId = 0
    }

    const dataValue = dataItem[field] === null ? '' : dataItem[field];


    if(field == "CapacidadeFDO" || field == "Capacidade_engarrafado"){
      
      return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
              popupSettings={{
                width: 'max-content',
              }}
              onChange={this.handleChange}
              value={dataValue !== "" && dataValue != undefined
                ? optionsCapacidades.find(c => c.value === (dataValue.value !== null ? dataValue.value : dataValue)) 
                : null}
              data={optionsCapacidades}
              textField="text"
              id='id-DropDownCellCapacidades'
              className='CapacidadesFDO'
            />
            : dataValue != null && dataValue != "" ? dataValue.text ? (parseFloat(dataValue.text.replace(" cl", ""))/100).toString() : dataValue.toString() : undefined}
        </td>
    );
    }
  }
    
}

export default DropDownCellCapacidadesFDO;